import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function AmericanExpress() {
    return (
        <SvgIcon>
            <svg width="23" height="16" viewBox="0 0 23 16" fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="0.5" y="0.5" width="22" height="15" rx="2" fill="#1F72CD" stroke="#D9D9D9" />
            </svg>
        </SvgIcon>
    );
}